/**
 * Parses Excel date values.
 * String format expected: dd/mm/yyyy (optional time).
 * Also accepts Excel serial numbers and Date instances.
 */
export const parseExcelDate = (value: unknown): Date | null => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getTime());
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const excelEpoch = new Date(1899, 11, 30);
    return new Date(excelEpoch.getTime() + value * 86400000);
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  const match = trimmed.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/
  );

  if (!match) {
    return null;
  }

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1;
  let year = parseInt(match[3], 10);
  const hours = match[4] !== undefined ? parseInt(match[4], 10) : 0;
  const minutes = match[5] !== undefined ? parseInt(match[5], 10) : 0;
  const seconds = match[6] !== undefined ? parseInt(match[6], 10) : 0;

  if (year < 100) {
    year += year < 50 ? 2000 : 1900;
  }

  const date = new Date(year, month, day, hours, minutes, seconds);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};
